<template>
    <div class="ws-button"  @click="copyToClipboard">
        <slot/>
    </div>
</template>

<script>
import Clipboard from "clipboard";

let btn;
export default {
    name: 'CopyBtn',
    props: {
        value: {
            type: String,
            required: true
        },
    },
    mounted() {
        
    },
    methods: {
        copyToClipboard() {
            navigator.clipboard.writeText(this.value);
            this.notifyStatus(200,'Copied','The link has been copied to your clipboard.');
        }
    },
    beforeDestroy() {
        if (btn) {
            btn.destroy()
        }
    }
}
</script>
